export const NOT_AVAILABLE = 'N/A';

// CaptionType values as transformed by the saga (parseEnumType converts numeric
// enum indices to their string keys from transactionCaptionTypes).
export const FIELD_CAPTION_TYPE = {
  ORDER_TOTAL: 'OrderTotal',
  PRICE_PER_UNIT: 'PricePerUnit',
  REFERENCE_NUMBER: 'ReferenceNumber',
  SUBMITTER: 'Submitter',
  SUMMARY: 'Summary',
  CREDIT_CARD: 'CreditCardLastFourDigits',
  SHIPPING_FEE: 'ShippingFee',
  INSURANCE_FEE: 'ShippingInsuranceFee',
  PRE_AUTH_AMOUNT: 'CreditCardAuthorizedAmount',
};

export const getTransactionField = (fields, captionType) =>
  (fields ?? []).find((f) => f.CaptionType === captionType) ?? null;

// Canonical timeline key for the cancelled step; the UI copy (status_cancelled)
// uses the British "cancelled" spelling regardless of what the BE sends.
export const CANCELLED_STEP_KEY = 'cancelled';

// The BE returns the American spelling for the cancelled state and its casing
// isn't guaranteed (history Key 'canceled', transaction StatusType 'Canceled',
// etc.). Match any of those so the UI consistently renders as cancelled.
export const isCancelledStatus = (value) => /^cancel/i.test(value ?? '');

// Normalizes the GET orders/sfh/history response into the shape the timeline
// renders. The BE returns a flat array (PascalCase), one entry per step:
//
// [
//   { Key: 'requestSubmitted', IsCompleted: true,  DateTime: '2026-06-23T05:36:59.17', Cancellable: true  },
//   { Key: 'inTransit',        IsCompleted: false, DateTime: null,                     Cancellable: false },
//   ...
// ]
//
// dateTime:    BE timestamp string when the step completed, null while pending
// cancellable: true only while the order can still be cancelled
//
// Returns [] when there's no data yet — the screen shows a loader while the
// feed is in flight, so nothing static is ever rendered as real history.
export function buildTimelineSteps(history) {
  if (!Array.isArray(history)) return [];
  return history.map((step) => {
    // The cancelled step comes back completed (IsCompleted: true); render it
    // with the terminal (red) styling rather than the completed blue check.
    // Normalize the BE key to CANCELLED_STEP_KEY so the status_cancelled label
    // resolves whatever spelling/casing the BE used.
    const cancelled = isCancelledStatus(step.Key);
    let status = 'pending';
    if (cancelled) status = 'cancelled';
    else if (step.IsCompleted) status = 'completed';
    return {
      key: cancelled ? CANCELLED_STEP_KEY : step.Key,
      status,
      dateTime: step.DateTime,
      cancellable: Boolean(step.Cancellable),
    };
  });
}
